import { api, formatApiErrorDetail } from "./api";

/**
 * Zentraler RPC-Wrapper für alle Business-Endpoints aus P-2.
 * Mappt HTTPException-Detail 1:1 auf eine deutsche Fehlermeldung.
 */
export async function callRpc(method, path, body) {
    try {
        const { data } = await api.request({
            url: path,
            method,
            data: body,
        });
        return { ok: true, data };
    } catch (e) {
        const detail = e.response?.data?.detail;
        return {
            ok: false,
            status: e.response?.status,
            error: formatApiErrorDetail(detail) || e.message || "Fehler",
        };
    }
}

export const rpc = {
    get: (path) => callRpc("get", path),
    post: (path, body) => callRpc("post", path, body),
    patch: (path, body) => callRpc("patch", path, body),
    put: (path, body) => callRpc("put", path, body),
    del: (path) => callRpc("delete", path),
};
